/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentAccountShared {
    getFixupPrototypeFunction() { return AwsSsmDocumentAccountShared.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentAccountShared>): AwsSsmDocumentAccountShared {
        let obj = Object.assign(new AwsSsmDocumentAccountShared(), model);
        AwsSsmDocumentAccountShared.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentAccountShared>): AwsSsmDocumentAccountShared {
        if (!model) return null;
        return AwsSsmDocumentAccountShared.newInstance(<AwsSsmDocumentAccountShared> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentAccountShared) {
        if (!obj) return;

        models.AwsSsmDocumentAccountShared.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentAccountShared): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentAccountShared.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * AWS Account Id to which the Document is shared.
     */
    account_id: string;

    /**
     * Version of the document which is shared with other accounts.
     */
    shared_document_version: string;

}
